export var PAGE_FUNCTION = "account details";
export var PAGE_SUBFUNCTION = "";
export var PAGE_CLOSE_MODAL = "closed_modal";
export var PAGE_NAME = { VIEW: "view", ERROR: "error" };
//# sourceMappingURL=analytics.js.map